import { DateTimeDetailValue } from "../../../../components/shared/details-cells/DateTimeDetailValue";
import DetailsCells from "../../../../components/shared/details-cells/DetailsCells";
import ACTION_LOGS_DATA_MODEL from "../../../../utils/constants/actionLogsDataModel";
import COMMON_LOGS_DATA_MODEL from "../../../../utils/constants/commonLogsDataModel";
import { DESCRIPTION_FIELD } from "../../../../utils/constants/descriptionField";
import {
  ApproverUserName,
  CustomDetailsCellStyled,
  Flex,
  RunLogWrapper,
  SystemStatusCell,
  GxpReadyCell,
  ActionTypeCell,
  CreatedAtCell,
  CreatedTimeAtCell,
  GxpRelevantCell,
  ConfigurationBaselineCell
} from "../../common-for-log-sheet-and-run-logs/table-common-meta-info";
import { getDateTimeDisplay, formatUtcToLocal } from "../../../../utils/helpers/text";

export const LogSheetClusterTableMeta = {
  expandable: true,
  ExpandedComponent: ({ item, infoMeta }) => (
    <Flex>
      <DetailsCells Wrapper={RunLogWrapper} item={item} infoMeta={infoMeta} CellWrapper={CustomDetailsCellStyled} />
    </Flex>
  ),
  expandedComponentProps: {
    infoMeta: {
      fields: [
        {
          label: ACTION_LOGS_DATA_MODEL.actionTime.value,
          component: ({ item }) => {
            if (item?.actionDateTime) {
              return <DateTimeDetailValue time={formatUtcToLocal(item.actionDateTime, { variant: 'time' })} skipTimeParse={true} />;
            }
            return <DateTimeDetailValue time={item?.actionTime} />;
          }
        },
        {
          label: COMMON_LOGS_DATA_MODEL.createdAtTime.value,
          component: CreatedTimeAtCell
        },
        {
          label: ACTION_LOGS_DATA_MODEL.materialNumber.value,
          field: ["materialNumber"]
        },
        {
          label: COMMON_LOGS_DATA_MODEL.operatorUserName.value,
          field: ["operatorUserName"]
        },
        {
          label: ACTION_LOGS_DATA_MODEL.ecrNumber.value,
          field: ["ecrNumber"]
        },
        {
          label: "Equipment relevant attributes",
          lookapVal: "divider"
        },
        {
          label: ACTION_LOGS_DATA_MODEL.gxpReady.value,
          field: ["gxpReady"]
        },
        {
          label: ACTION_LOGS_DATA_MODEL.systemStatus.value,
          field: ["systemStatus"]
        },
        {
          label: COMMON_LOGS_DATA_MODEL.gxpRelevant.value,
          component: GxpRelevantCell
        },
        DESCRIPTION_FIELD
      ]
    }
  },
  fields: {
    detailExpander: {
      sortable: false,
      text: ""
    },
    actionDate: {
      sortable: true,
      text: ACTION_LOGS_DATA_MODEL.actionDate.value,
      component: ({ item }) => getDateTimeDisplay(item, 'actionDateTime', 'actionDate')
    },
    createdAt: {
      sortable: true,
      text: COMMON_LOGS_DATA_MODEL.createdAt.value,
      component: CreatedAtCell
    },
    subEquipment: {
      text: COMMON_LOGS_DATA_MODEL.subEquipment.value
    },
    action: {
      text: ACTION_LOGS_DATA_MODEL.actionType.value,
      component: ActionTypeCell
    },
    gxpReady: {
      text: ACTION_LOGS_DATA_MODEL.gxpReady.value,
      component: GxpReadyCell
    },
    systemStatus: {
      text: ACTION_LOGS_DATA_MODEL.systemStatus.value,
      component: SystemStatusCell
    },
    gxpRelevant: {
      text: COMMON_LOGS_DATA_MODEL.gxpRelevant.value,
      component: GxpRelevantCell
    },
    configurationBaseline: {
      text: ACTION_LOGS_DATA_MODEL.configurationBaseline.value,
      component: ConfigurationBaselineCell
    },
    ecrNumber: {
      text: ACTION_LOGS_DATA_MODEL.ecrNumber.value
    },
    ...ApproverUserName,
    description: {
      text: COMMON_LOGS_DATA_MODEL.description.value
    },
    operatorUserName: {
      text: COMMON_LOGS_DATA_MODEL.operatorUserName.value
    }
  }
};

export const logSheetTabletSizes = {
  actionDate: "0 1 10%",
  createdAt: "0 1 10%",
  equipmentModel: "0 1 10%",
  action: "0 1 10%",
  subEquipment: "0 1 12%",
  approverUserName: "0 1 8%",
  gxpReady: "0 1 8%",
  systemStatus: "0 1 8%",
  gxpRelevant: "0 1 8%",
  configurationBaseline: "0 1 8%",
  actionButtons: "0 0 132px"
};

export const logSheetRegularSizes = {
  actionDate: "0 1 8%",
  createdAt: "0 1 10%",
  equipmentModel: "0 1 10%",
  action: "0 1 10%",
  subEquipment: "0 1 12%",
  approverUserName: "0 1 10%",
  gxpReady: "0 1 8%",
  systemStatus: "0 1 8%",
  gxpRelevant: "0 1 8%",
  configurationBaseline: "0 1 8%",
  actionButtons: "0 0 132px"
};

export default LogSheetClusterTableMeta;
